import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"background":"#ECECEC"} }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "title" }, "Vendors", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_card, { bordered: false }, {
      default: _withCtx(() => [
        _hoisted_2,
        _createVNode(_component_a_tabs, { style: {"text-align":"left"} }, {
          default: _withCtx(() => [
            _createVNode(_component_a_tab_pane, {
              key: "1",
              tab: "Active"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_DataTable, {
                  loading: _ctx.loading,
                  data: _ctx.active.data,
                  columns: _ctx.fields,
                  pagination: _ctx.active,
                  showDeactivateButton: true,
                  showCreateButton: false,
                  showEditButton: false,
                  showDeleteButton: false,
                  onInactivate: _ctx.activate,
                  onFilter: _ctx.filterRecordActive
                }, null, 8, ["loading", "data", "columns", "pagination", "onInactivate", "onFilter"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_tab_pane, {
              key: "2",
              tab: "Inactive"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_DataTable, {
                  loading: _ctx.loading,
                  data: _ctx.inactive.data,
                  columns: _ctx.fields,
                  pagination: _ctx.inactive,
                  showActivateButton: true,
                  showCreateButton: false,
                  showEditButton: false,
                  showDeleteButton: false,
                  onActivate: _ctx.activate,
                  onFilter: _ctx.filterRecordInactive
                }, null, 8, ["loading", "data", "columns", "pagination", "onActivate", "onFilter"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}